// Tiny safe-ish markdown-to-HTML for static blog posts.
// Supports: ## h2, ### h3, **bold**, - lists, | tables |, paragraphs, line breaks.
// No raw HTML allowed in the input (we escape angle brackets first).

const escapeHtml = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const inline = (s: string) =>
  s
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");

export const renderMarkdown = (md: string): string => {
  const lines = escapeHtml(md).split("\n");
  const out: string[] = [];
  let inList = false;
  let inTable = false;
  let buf: string[] = [];

  const flushList = () => {
    if (inList) {
      out.push(`<ul>${buf.map((l) => `<li>${inline(l)}</li>`).join("")}</ul>`);
      inList = false;
      buf = [];
    }
  };
  const flushTable = () => {
    if (inTable) {
      const [head, , ...rows] = buf;
      const headers = head
        .split("|")
        .map((c) => c.trim())
        .filter(Boolean);
      const body = rows.map(
        (r) =>
          `<tr>${r
            .split("|")
            .map((c) => c.trim())
            .filter(Boolean)
            .map((c) => `<td>${inline(c)}</td>`)
            .join("")}</tr>`,
      );
      out.push(
        `<table><thead><tr>${headers
          .map((h) => `<th>${inline(h)}</th>`)
          .join("")}</tr></thead><tbody>${body.join("")}</tbody></table>`,
      );
      inTable = false;
      buf = [];
    }
  };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (line.startsWith("## ")) {
      flushList();
      flushTable();
      out.push(`<h2>${inline(line.slice(3))}</h2>`);
    } else if (line.startsWith("### ")) {
      flushList();
      flushTable();
      out.push(`<h3>${inline(line.slice(4))}</h3>`);
    } else if (line.startsWith("- ")) {
      flushTable();
      inList = true;
      buf.push(line.slice(2));
    } else if (line.startsWith("|")) {
      flushList();
      inTable = true;
      buf.push(line);
    } else if (line === "") {
      flushList();
      flushTable();
    } else {
      flushList();
      flushTable();
      out.push(`<p>${inline(line)}</p>`);
    }
  }
  flushList();
  flushTable();
  return out.join("\n");
};
